var $protobuf = {util:{},roots:{default:{}}};
// Common aliases
var $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export var OperationEvent = (function() {

    /**
     * Properties of an OperationEvent.
     * @exports IOperationEvent
     * @interface IOperationEvent
     * @property {number|null} [count] OperationEvent count
     * @property {string|null} [cv] OperationEvent cv
     * @property {string|null} [serviceName] OperationEvent serviceName
     * @property {string|null} [sessionKey] OperationEvent sessionKey
     * @property {number|null} [durationMs] OperationEvent durationMs
     * @property {boolean|null} [success] OperationEvent success
     * @property {string|null} [resultDescription] OperationEvent resultDescription
     * @property {string|null} [resultJSON] OperationEvent resultJSON
     * @property {string|null} [resultSignature] OperationEvent resultSignature
     * @property {string|null} [operationName] OperationEvent operationName
     * @property {string|null} [resourceId] OperationEvent resourceId
     * @property {string|null} [dimension0] OperationEvent dimension0
     * @property {string|null} [dimension1] OperationEvent dimension1
     * @property {string|null} [dimension2] OperationEvent dimension2
     * @property {string|null} [dimension3] OperationEvent dimension3
     * @property {string|null} [clientAppName] OperationEvent clientAppName
     * @property {string|null} [clientAppPlatform] OperationEvent clientAppPlatform
     * @property {string|null} [clientRuntimeVersion] OperationEvent clientRuntimeVersion
     * @property {string|null} [clientAppVersion] OperationEvent clientAppVersion
     * @property {string|null} [clientReleaseAudienceGroup] OperationEvent clientReleaseAudienceGroup
     * @property {string|null} [clientReleaseChannel] OperationEvent clientReleaseChannel
     * @property {string|null} [clientReleaseFork] OperationEvent clientReleaseFork
     * @property {string|null} [clientSessionId] OperationEvent clientSessionId
     * @property {string|null} [clientFlights] OperationEvent clientFlights
     * @property {string|null} [clientIPRange] OperationEvent clientIPRange
     * @property {string|null} [clientDocSessionId] OperationEvent clientDocSessionId
     * @property {string|null} [clientDeviceId] OperationEvent clientDeviceId
     * @property {string|null} [clientUserAgent] OperationEvent clientUserAgent
     * @property {string|null} [userType] OperationEvent userType
     * @property {string|null} [userId] OperationEvent userId
     * @property {string|null} [userTenantId] OperationEvent userTenantId
     * @property {string|null} [joinContextId] OperationEvent joinContextId
     * @property {string|null} [ariaTenant] OperationEvent ariaTenant
     * @property {string|null} [ariaNamespace] OperationEvent ariaNamespace
     * @property {string|null} [dataFields] OperationEvent dataFields
     */

    /**
     * Constructs a new OperationEvent.
     * @exports OperationEvent
     * @classdesc Represents an OperationEvent.
     * @implements IOperationEvent
     * @constructor
     * @param {IOperationEvent=} [properties] Properties to set
     */
    function OperationEvent(properties) {
        if (properties)
            for (var prop in properties)
                if (properties[prop] != null)
                    this[prop] = properties[prop];
    }

    /**
     * OperationEvent count.
     * @member {number} count
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.count = 0;

    /**
     * OperationEvent cv.
     * @member {string} cv
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.cv = "";

    /**
     * OperationEvent serviceName.
     * @member {string} serviceName
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.serviceName = "";

    /**
     * OperationEvent sessionKey.
     * @member {string} sessionKey
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.sessionKey = "";

    /**
     * OperationEvent durationMs.
     * @member {number} durationMs
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.durationMs = 0;

    /**
     * OperationEvent success.
     * @member {boolean} success
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.success = false;

    /**
     * OperationEvent resultDescription.
     * @member {string} resultDescription
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.resultDescription = "";

    /**
     * OperationEvent resultJSON.
     * @member {string} resultJSON
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.resultJSON = "";

    /**
     * OperationEvent resultSignature.
     * @member {string} resultSignature
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.resultSignature = "";

    /**
     * OperationEvent operationName.
     * @member {string} operationName
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.operationName = "";

    /**
     * OperationEvent resourceId.
     * @member {string} resourceId
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.resourceId = "";

    /**
     * OperationEvent dimension0.
     * @member {string} dimension0
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.dimension0 = "";

    /**
     * OperationEvent dimension1.
     * @member {string} dimension1
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.dimension1 = "";

    /**
     * OperationEvent dimension2.
     * @member {string} dimension2
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.dimension2 = "";

    /**
     * OperationEvent dimension3.
     * @member {string} dimension3
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.dimension3 = "";

    /**
     * OperationEvent clientAppName.
     * @member {string} clientAppName
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.clientAppName = "";

    /**
     * OperationEvent clientAppPlatform.
     * @member {string} clientAppPlatform
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.clientAppPlatform = "";

    /**
     * OperationEvent clientRuntimeVersion.
     * @member {string} clientRuntimeVersion
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.clientRuntimeVersion = "";

    /**
     * OperationEvent clientAppVersion.
     * @member {string} clientAppVersion
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.clientAppVersion = "";

    /**
     * OperationEvent clientReleaseAudienceGroup.
     * @member {string} clientReleaseAudienceGroup
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.clientReleaseAudienceGroup = "";

    /**
     * OperationEvent clientReleaseChannel.
     * @member {string} clientReleaseChannel
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.clientReleaseChannel = "";

    /**
     * OperationEvent clientReleaseFork.
     * @member {string} clientReleaseFork
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.clientReleaseFork = "";

    /**
     * OperationEvent clientSessionId.
     * @member {string} clientSessionId
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.clientSessionId = "";

    /**
     * OperationEvent clientFlights.
     * @member {string} clientFlights
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.clientFlights = "";

    /**
     * OperationEvent clientIPRange.
     * @member {string} clientIPRange
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.clientIPRange = "";

    /**
     * OperationEvent clientDocSessionId.
     * @member {string} clientDocSessionId
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.clientDocSessionId = "";

    /**
     * OperationEvent clientDeviceId.
     * @member {string} clientDeviceId
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.clientDeviceId = "";

    /**
     * OperationEvent clientUserAgent.
     * @member {string} clientUserAgent
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.clientUserAgent = "";

    /**
     * OperationEvent userType.
     * @member {string} userType
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.userType = "";

    /**
     * OperationEvent userId.
     * @member {string} userId
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.userId = "";

    /**
     * OperationEvent userTenantId.
     * @member {string} userTenantId
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.userTenantId = "";

    /**
     * OperationEvent joinContextId.
     * @member {string} joinContextId
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.joinContextId = "";

    /**
     * OperationEvent ariaTenant.
     * @member {string} ariaTenant
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.ariaTenant = "";

    /**
     * OperationEvent ariaNamespace.
     * @member {string} ariaNamespace
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.ariaNamespace = "";

    /**
     * OperationEvent dataFields.
     * @member {string} dataFields
     * @memberof OperationEvent
     * @instance
     */
    OperationEvent.prototype.dataFields = "";

    return OperationEvent;
})();
